module.exports = __webpack_public_path__ + "a1c84f7ea46aee0a50670371b09200ca.png";